export const dialogHeaderPaddingClassName = 'px-4 py-4';

export const dialogMutedHeaderChromeClassName =
  'border-b border-gray-400 bg-slate-200/65 text-slate-900';

export const alertDialogMutedHeaderChromeClassName =
  'border-b border-slate-300 bg-slate-100 text-slate-900';

export const dialogHeaderVariantClasses = {
  default: 'flex flex-col gap-2',
  muted: [
    'group/dialog-header -mx-4 -mt-4 flex flex-col gap-1.5 rounded-t-xl',
    dialogMutedHeaderChromeClassName,
    dialogHeaderPaddingClassName,
  ].join(' '),
  primary: [
    'group/dialog-header -mx-4 -mt-4 flex flex-col gap-1.5 rounded-t-xl',
    'bg-primary-600 text-white',
    dialogHeaderPaddingClassName,
  ].join(' '),
};

export const dialogFooterBaseClassName = [
  '-mx-4 -mb-4 p-4',
  'flex flex-col-reverse gap-2',
  'rounded-b-xl bg-muted/50',
  'sm:flex-row sm:justify-end',
].join(' ');

export const dialogFooterDividerClassName = 'border-t border-slate-400';

export const dialogFooterTertiaryButtonClassName = [
  '[&_[data-slot=button][data-variant=ghost]]:text-foreground',
  '[&_[data-slot=button][data-variant=ghost]]:hover:bg-background',
].join(' ');

export const alertDialogCompactFooterDividerClassName = 'border-t border-slate-300';

export const alertDialogHeaderVariantClasses = {
  muted: [
    'group/alert-dialog-header -mx-4 -mt-4 flex flex-col gap-1.5 rounded-t-xl',
    alertDialogMutedHeaderChromeClassName,
  ].join(' '),
  destructive: [
    'group/alert-dialog-header -mx-4 -mt-4 flex flex-col gap-1.5 rounded-t-xl',
    'bg-destructive text-white',
  ].join(' '),
};

export const alertDialogHeaderCompactPaddingClassName = 'px-6 py-5';

export const alertDialogFooterVariantClasses = {
  muted: dialogFooterBaseClassName,
  destructive: [
    '-mx-4 -mb-4 p-4',
    'flex flex-col-reverse gap-2',
    'rounded-b-xl bg-destructive/10',
    'sm:flex-row sm:justify-end',
  ].join(' '),
};

export const alertDialogFooterDestructiveDividerClassName = 'border-t border-destructive/20';

/**
 * Dialog 寬度 token：以寬度扣 gutter，勿對 fixed 置中 Content 用 mx-*。
 * 每個尺度必須是靜態字串（禁止 `sm:max-w-${size}`）。
 */
export const dialogSmMaxWidthClassName = 'w-[calc(100%-2rem)] sm:max-w-sm';
export const dialogMdMaxWidthClassName = 'w-[calc(100%-2rem)] sm:max-w-md';
export const dialogLgMaxWidthClassName = 'w-[calc(100%-2rem)] sm:max-w-lg';
export const dialogXlMaxWidthClassName = 'w-[calc(100%-2rem)] sm:max-w-xl';
export const dialog2xlMaxWidthClassName = 'w-[calc(100%-2rem)] sm:max-w-2xl';
export const dialog3xlMaxWidthClassName = 'w-[calc(100%-2rem)] sm:max-w-3xl';
export const dialog4xlMaxWidthClassName = 'w-[calc(100%-2rem)] sm:max-w-4xl';
export const dialog5xlMaxWidthClassName = 'w-[calc(100%-2rem)] sm:max-w-5xl';

/** 寬版選料／寬表：與 5xl 同一字串（既有 import 不改） */
export const dialogWideMaxWidthClassName = dialog5xlMaxWidthClassName;

export const dialogMaxWidthClassNames = {
  sm: dialogSmMaxWidthClassName,
  md: dialogMdMaxWidthClassName,
  lg: dialogLgMaxWidthClassName,
  xl: dialogXlMaxWidthClassName,
  '2xl': dialog2xlMaxWidthClassName,
  '3xl': dialog3xlMaxWidthClassName,
  '4xl': dialog4xlMaxWidthClassName,
  '5xl': dialog5xlMaxWidthClassName,
  wide: dialogWideMaxWidthClassName,
};

/** 寬版表格 Dialog：壓縮 header／body／footer 垂直 gap */
export const dialogContentCompactGapClassName = 'gap-2';

/**
 * Dialog 與 viewport 上下留白。
 * 高度只在此維護；業務層禁止另寫 max-h 修同樣問題。
 */
export const dialogChromeVarClassName = '[--dialog-chrome:2rem]';

export const dialogViewportMaxHeightClassName = [
  dialogChromeVarClassName,
  'max-h-[calc(100dvh-var(--dialog-chrome))]',
].join(' ');

/** AppDialog shell：header / body / footer；短內容維持自然高度 */
export const dialogShellGridClassName = 'grid-rows-[auto_minmax(0,1fr)_auto]';

/** AppDialog body：僅此區垂直捲動 */
export const dialogBodyScrollClassName = 'min-h-0 overflow-y-auto';

/**
 * AppDialog body：填滿 grid 列、不捲；交給內層列表 overflow-y-auto。
 * 與 dialogBodyScrollClassName 併用時以本常數覆寫（tailwind-merge）。
 */
export const dialogBodyFillClassName = 'flex min-h-0 flex-col overflow-hidden';
